import React, { useState } from 'react';
import { Popover, Box, Tabs, Tab } from '@mui/material';

const accent = '#7C3AED';

const EMOJI_CATEGORIES = {
  'Caritas': ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😊','😇','🥰','😍','🤩','😘','😗','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','😐','😑','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠','🥳','😎','🤓','🧐'],
  'Gestos': ['👍','👎','👊','✊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✌️','🤟','🤘','👌','🤏','👈','👉','👆','👇','☝️','✋','🤚','🖐️','🖖','👋','🤙','💪'],
  'Corazones': ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','♥️','🔥','⭐','✨','💫','🌟'],
  'Objetos': ['📱','💻','⌨️','🖥️','🖨️','📞','☎️','📧','📬','📋','📎','🔗','📌','📍','🗂️','📁','📂','🗓️','📅','📆','🔔','🔕','📣','📢','🎉','🎊','🎈','🎁','🏆','🥇','✅','❌','⚠️','ℹ️','❓','❗']
};

const CATEGORY_KEYS = Object.keys(EMOJI_CATEGORIES);

const EmojiPickerPopover = ({ anchorEl, open, onClose, onSelect }) => {
  const [tab, setTab] = useState(0);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: 320,
          maxHeight: 350,
          boxShadow: '0 4px 20px rgba(0,0,0,0.16)',
          border: '1px solid #d1d5db',
        }
      }}
    >
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        variant="scrollable"
        scrollButtons={false}
        sx={{
          minHeight: 36,
          borderBottom: '1px solid #d1d5db',
          '& .MuiTab-root': { minHeight: 36, minWidth: 'auto', px: 1.5, fontSize: 11 },
          '& .MuiTabs-indicator': { backgroundColor: accent }
        }}
      >
        {CATEGORY_KEYS.map(k => <Tab key={k} label={k} />)}
      </Tabs>
      <Box sx={{ p: 1, display: 'flex', flexWrap: 'wrap', gap: 0.3, maxHeight: 260, overflow: 'auto' }}>
        {EMOJI_CATEGORIES[CATEGORY_KEYS[tab]].map((emoji, i) => (
          <Box
            key={i}
            onClick={() => { onSelect(emoji); onClose(); }}
            sx={{
              width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 22, borderRadius: 1, cursor: 'pointer',
              '&:hover': { background: '#f3f4f6' },
              transition: 'background 0.15s'
            }}
          >
            {emoji}
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

export default EmojiPickerPopover;
